import React, { useEffect, useState } from 'react'
import { IconButton, Typography, Grid, Paper, Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import { makeStyles } from '@material-ui/core/styles'
import LoadingCircle from '../components/common/LoadingCircle'
import LoadingButton from '../components/LoadingButton'
import ItemDetail from '../components/ItemDetail'
import { smallScreenWidth } from '../constants/AppConstants'
import fetchFromAthena from '../functions/FetchFromAthena'
import OpenSearchDropdown from '../components/OpenSearchDropdown'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '1rem 1rem 0 1rem'
  }
}))

export default function Item (props) {
  const classes = useStyles()
  const { credentials } = props.fetchInitialData
  const [state, setstate] = useState({
    itemData: null,
    gtinData: null,
    groups: [],
    fetched: true,
    isFetching: false
  })
  const [headers, setHeaders] = React.useState({
    itemGroup: null,
    item: null
  })
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)
  const [showHeaders, setShowHeaders] = React.useState(true)


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const itemGroup = urlParams.get('itemGroup')
    const item = urlParams.get('item')

    if (itemGroup && item) {
      setstate({ ...state, isFetching: true })
      setHeaders({ itemGroup, item })
      fetchItem(itemGroup, item)
      setShowHeaders(false)
    }
  }, [])

  const fetchItem = async (itemGroup, item) => {
    try {
      setstate({ ...state, isFetching: true })

      const queries = ['item_read']

        const data = await Promise.allSettled(
            queries.map(query =>
                fetchFromAthena({
                    queryName: query,
                    headers: {itemGroup,item},
                    accessToken: credentials.user.accessToken,
                    credentials: credentials
                })
            )
        ).then(results => {
            return results
        })

        if(!data[0].value[0]) {
          props.createSnack('Item not found or secured', 'warning', 3000)

          setstate({
            ...state,
            isFetching: false
          })
          
          return
        }
      
      setstate({
        ...state,
        itemData: data[0].value[0],
        isFetching: false
      })
    } catch (e) {
      console.log(e)
    }
  }
  const getItem = async e => {
    e.preventDefault()
    await fetchItem(headers.itemGroup, headers.item)
  }

  const handleChange = (name, value) => {
    setHeaders({ ...headers, [name]: value })
  }

  const { itemData,gtinData } = state

  if (!state.fetched) {
    return <LoadingCircle />
  }
  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Item (IC11)
      </Typography>

      <div className={classes.root}>
      {showHeaders && (
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={getItem}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='itemGroup'
                  required
                  width='200px'
                  label='Item Group'
                  page="ITEM"
                  entity="ITEMGROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    handleChange('itemGroup', val?.VALUE || null)
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='item'
                  required
                  disabled={!headers.itemGroup}
                  width='320px'
                  label='Item'
                  page="ITEM"
                  entity="ITEM"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    ITEMGROUP: headers.itemGroup
                  }}
                  onChange={(val) => {
                    handleChange('item', val?.VALUE || null)
                  }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isFetching}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(
                headers.itemGroup ||
                headers.item
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders({
                      itemGroup: null,
                      item: null
                    })
                    setstate({
                      ...state,
                      itemData: null
                    })
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>
      )}
        {itemData && (
          <Grid
            item
            xs={12}
            style={{ position: 'relative', marginTop: '1rem' }}
          >
            <ItemDetail {...props} itemData={itemData} gtinData={gtinData}/>
          </Grid>
        )}
      </div>
    </div>
  )
}
